import type { IUserPortal } from '@/interfaces/UserAccountInfo.interface.ts';

type SenderAccount = Pick<Partial<IUserPortal>, 'pvPersonGivenName' | 'pvPersonSurName' | 'email' | 'currentPositions'>;

/**
 * Who the support email says sent it: the signed-in user, their selected group and their position
 * names (ported from REP). A missing group or position list sends empty. A missing name or email
 * also becomes '', but eti-ui requires both, so the form shows an error and does not send.
 */
export const contactSupportSender = (account: SenderAccount | null | undefined, groupName: string | null | undefined) => ({
  name: `${account?.pvPersonGivenName || ''} ${account?.pvPersonSurName || ''}`.trim(),
  email: account?.email || '',
  group: groupName || '',
  positions: (account?.currentPositions ?? []).map((position) => position.n).filter((name): name is string => !!name),
});
